export const hasElementScrollbar = (element) => (element && element.scrollHeight > element.clientHeight);
